import React, { useCallback, useContext, useState } from 'react'
import { Avatar, Button, Container, TextField, Typography } from '@material-ui/core'
import { DialpadRounded } from '@material-ui/icons'
import { makeStyles } from '@material-ui/core/styles'

import { usePromoCodesApi } from '../../../../store/hooks/use-promo-codes-api'
import { useSelectors } from '../../../../store/hooks/selectors/use-selectors'
import { setPromoCodeRefusal } from '../../../../store/actions/promocodes'
import { context } from '../../../../store/context'

import { styles } from './styles'

// Once per module: makeStyles called inside a render built a new JSS sheet,
// with new class names, on every render (booking screen, 11 Oct 2026).
const useStyles = makeStyles(styles)

export const ApplyPromoCode = React.memo(() => {
  const classes = useStyles()
  const [promoCode, setPromoCode] = useState('')
  const { apiApplyPromoCode } = usePromoCodesApi()
  const { dispatch } = useContext(context)
  // A refused code is said under the field (26 Oct 2026), cleared on edit.
  const { promoCodeRefusal } = useSelectors()

  const handlePromoCode = useCallback(
    event => {
      event.preventDefault()
      apiApplyPromoCode(promoCode)
    },
    [promoCode, apiApplyPromoCode]
  )

  return (
    <Container maxWidth="xs" className={classes.container}>
      <Avatar className={classes.avatar}>
        <DialpadRounded />
      </Avatar>
      <Typography component="h1" variant="h5">
        Enter Promo Code
      </Typography>
      <form className={classes.form} noValidate onSubmit={handlePromoCode}>
        <TextField
          value={promoCode}
          onChange={event => {
            setPromoCode(event.target.value)
            if (promoCodeRefusal) dispatch(setPromoCodeRefusal(null))
          }}
          variant="outlined"
          margin="normal"
          autoComplete="off"
          required
          fullWidth
          id="promo_code"
          label="Promo code"
          name="promo_code"
          autoFocus
          error={!!promoCodeRefusal}
          helperText={promoCodeRefusal?.message || ''}
          FormHelperTextProps={{ role: 'alert', 'data-testid': 'promo-code-notice', 'data-reason': promoCodeRefusal?.reason || '' }}
        />
        <Button type="submit" fullWidth variant="contained" color="primary" className={classes.submit}>
          Apply Promo Code
        </Button>
      </form>
    </Container>
  )
})
